import React from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon';

const VerifiedIcon = ({ size }) => {
  let iconSize;
  if (size) {
    iconSize = size;
  } else {
    iconSize = 'S';
  }

  return (
    <div className={`verified-icon icon icon-${iconSize}`}>
      <Icon name="tick" size="100" fill="white" />
    </div>
  );
};

VerifiedIcon.propTypes = {
  size: PropTypes.string,
};

export default VerifiedIcon;



// WEBPACK FOOTER //
// ./library/app/components/Global/Icons/VerifiedIcon.js